import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-redeemed',
  templateUrl: './modal-redeemed.component.html',
  styleUrls: ['./modal-redeemed.component.scss']
})
export class ModalRedeemedComponent implements OnInit {

  @ViewChild('redeemedModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };

  message = '';
  myProfile: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.modalServ.onRedeemed.subscribe(req => {
      this.getMyProfile();
      this.message = req.message;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onRedeemedHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyProfile(){
    this.myProfile = await this.utility.getMyProfile();
  }

  confirm() {
    this.hide();
    this.modalServ.onRedeemedSuccess.emit({status: 'success'});
  }

  close() {
    this.hide();
    this.modalServ.onRedeemedSuccess.emit({status: 'success'});
  }

  onEditImage() {
    
  }

}
